module.exports = __webpack_public_path__ + "static/media/boyds-consultants.965b725d.jpg";